import { theme } from '@zappyrent/hundop';
import { Suspense } from 'react';
import { ThemeProvider } from 'styled-components';

import Router from '../../components/Router';
import Splash from '../../components/Splash';
import { ToastProvider } from '../../contexts/ToastProvider';
import { AppGlobalStyle } from './App.styles';
import '../../i18n';

//just a comment
const App = (): JSX.Element => {
  return (
    <>
      <AppGlobalStyle />
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <Suspense fallback={<Splash />}>
            <Router />
          </Suspense>
        </ToastProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
